import List from './List'
import Detail from './Detail'

const Articles = () => ({
  path: '/users',
  children: [List(), Detail()],
})

export default Articles
